import {ADICIONAR_FILTRO_BAGAGEM, LISTAR_FILTROS_BAGAGEM, REMOVER_FILTRO_BAGAGEM} from '../../actions/types'
import {filtroExiste} from '../../util/filtros'

const initialState = undefined

const initial = {
}

export const filtrosAdicionadosBagagem = (state = [], action = initialState) => {
  switch (action.type) {
    case ADICIONAR_FILTRO_BAGAGEM: {
      if (!filtroExiste(state, action.payload)) {
        return state.concat(action.payload)
      }
      return state
    }

    case REMOVER_FILTRO_BAGAGEM: {
      const copia = [...state]
      return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
    }

    default:
      return state
  }
}

export const filtrosBagagem = (state = initial, action) => {
  switch (action.type) {
    case LISTAR_FILTROS_BAGAGEM: {
      return action.payload.data
    }
    default:
      return state
  }
}
